/*!

=========================================================
* Central System - v1.0.0
=========================================================

* Coded by Aircode

=========================================================

*/
import React from "react";

import "../../../../assets/vendor/nucleo/css/nucleo.css";
import "../../../../assets/vendor/font-awesome/css/font-awesome.min.css";
import "../../../../assets/scss/argon-design-system-react.scss?v1.1.0";

import "assets/fonts/Inter-VariableFont.ttf";

// section components
import './Index.css'
import Teaser from "./Teaser";
import StoreNavbar from "../../../../components/Navbars/StoreNavbar/Index";
import CardsOffer from "./CardsOffer";
import Manager from "./Manager";
import CardsProducts from "./CardsProducts";
import About from "./About";
import Footer from "../../../../components/Footers/StoreFooter/Footer";

class Home extends React.Component {
  state = {};

  componentDidMount() {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    this.refs.main.scrollTop = 0;
  }

  render() {
    return (
      <div className="main-landing-page">

        <StoreNavbar />

        <main ref="main">

          <Teaser></Teaser>

          <CardsProducts></CardsProducts>

          <CardsOffer></CardsOffer>

          <Manager></Manager>

          <About></About>

          <Footer></Footer>
          
        </main>

      </div>
    );
  }
}

export default Home;
